import { createStore } from 'vuex'
import {vuexModule as user} from './user';
import {AxiosRequestConfig} from 'axios';

/**
 * @typedef {import('./user/types').UserProfile} UserProfile
 *
 * @typedef {object} RootState
 * @property {boolean} loading application loading
 */

/** @type {import('vuex').Module<RootState>} */
const store = {
  state: {
    loading: true,
  },
  modules: {
    user,
  },
  actions: {
    /** Update user dashboard data
     * @param {ActionContext} context
     * @return {Promise<any>}
     */
    async fetchInfo({rootGetters}) {
        /** @type {import('axios').AxiosInstance} */
        const client = rootGetters.$client;
        let error = '';
        let code = 200;
        const data = await client.get('/info/')
          .then(res => {
            if (res.status === 200) return res.data;
            return error = `Error ${code = res.status}`, null;
          })
          .catch(err => {
            error = err.toString();
            code = err.response?.status || 0;
            return null;
          });

        let countries = [];
        let genders = [];
        data.info.forEach(v => {
          if (v.countries?.length) countries = v.countries;
          if (v.genders?.length) genders = v.genders;
        });
        return {countries, genders};
    },
  },
  getters: {
    $client: (state, getters) => getters['$client/axios'],
    username: (state) => {
      if (!state.user.profile) return undefined;
      const {first_name: first, last_name: last, email} = state.user.profile;
      const username = `${first || ''} ${last || ''}`.trim();
      return username || email || 'Username';
    },
  },
};

export default createStore(store);
